import React, { useState, useRef } from "react";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { Avatar } from "primereact/avatar";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../utils/localStorage";

const CardData = [
  {
    id: 1,
    name: "Store Profile",
    // account
    backgroundImage: "Icons/profile.png",
    url: "/StoreProfile",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 2,
    name: "Rider Jobs",
    // motorbike
    backgroundImage:
      "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Pickup_Request.gif",
    url: "/RiderJobs",
    height: 40,
    width: 45,
    // tintColor: '#2B70D7',
  },
  {
    id: 3,
    name: "Warehouse",
    // warehouse
    backgroundImage: "warehouse/warehouse_4.png",
    url: "/StoreWarehouse",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
   {
    id: 18,
    name: "WH Order Report",
    // receipt
    backgroundImage: "images/summary.png",
    url: "/WarehouseOrderStatusReport",
    height: 30,
    width: 30,
    tintColor: null,
  },
  {
    id: 4,
    name: "Challan",
    // receipt
    backgroundImage: "images/receipt.png",
    url: "/ChallanList",
    height: 30,
    width: 30,
    tintColor: null,
  },
  {
    id: 14,
    name: "B2B Challan",
    // receipt
    backgroundImage: "images/receipt.png",
    url: "/B2BChallanList",
    height: 30,
    width: 30,
    tintColor: null,
  },
  {
    id: 15,
    name: "Rack Model",
    // receipt
    backgroundImage: "images/receipt.png",
    url: "/RackAutoModel",
    height: 30,
    width: 30,
    tintColor: null,
  },
  {
    id: 16,
    name: "Rack Model",
    // receipt
    backgroundImage: "images/receipt.png",
    url: "/RackManualModel",
    height: 30,
    width: 30,
    tintColor: null,
  },
  {
    id: 17,
    name: "Rack Model Report",
    // receipt
    backgroundImage: "images/receipt.png",
    url: "/RackModelReport",
    height: 30,
    width: 30,
    tintColor: null,
  },
  {
    id: 10,
    name: "External Challan",
    // receipt
    backgroundImage: "images/receipt.png",
    url: "/StoreExternalWarehouseChallan",
    height: 30,
    width: 30,
    tintColor: null,
  },
  {
    id: 5,
    name: "Collection Report",
    backgroundImage: "images/summary.png",
    url: "/Reports",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 6,
    name: "Order Delivered",
    backgroundImage: "warehouse/delivery-boy.png",
    url: "/OrderDelivered",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 7,
    name: "Stock",
    backgroundImage: "warehouse/stocks.png",
    url: "/StoreGarmentStock",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 9,
    name: 'Cash Book',
    backgroundImage: 'images/summary.png',
    url: '/Cashbook',
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 11,
    name: 'Bulk Processing',
    backgroundImage: 'images/cash-payment.png',
    url: '/BulkProcessingList',
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 12,
    name: 'W Notification',
    backgroundImage: 'images/WhatsApplogo.png',
    url: '/Whatsapp-Notification',
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 13,
    name: 'Subscription & Packages',
    backgroundImage: 'Laundy_App_Icons_Gifs/Packages_GIFs/package1.gif',
    // url: '/Package-Log',
    url: '/Subscription-Package',
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 8,
    name: "LogOut",
    backgroundImage: "Icons/logout.png",
    url: "/LogOut",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
];
const CardDataRider = [
  {
    id: 1,
    name: "Store Profile",
    backgroundImage: "Icons/profile.png",
    url: "/MyProfile",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
  {
    id: 2,
    name: "Rider Jobs",
    backgroundImage:
      "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Pickup_Request.gif",
    url: "/RiderJobs",
    height: 40,
    width: 45,
    // tintColor: '#2B70D7',
  },

  {
    id: 3,
    name: "LogOut",
    backgroundImage: "Icons/logout.png",
    url: "/LogOut",
    height: 30,
    width: 30,
    // tintColor: '#2B70D7',
  },
];

export default function StoreMenu({ visible, setVisible }) {
  const navigate = useNavigate();
  const { brandProfileData, storeData, userProfileData, userProfileRole } =
    getUserData();

  const userRole = userProfileRole;

  const filteredCardData = CardData;

  const renderCardItem = () => {
    return CardData?.map((item, index) => {
      const wareHouseModel =
        brandProfileData.wareHouseModel && storeData.wareHouseModel;

      const packageCarryForwardStore = storeData.packageCarryForward;
          // If wareHouseModel is true and item.id is 10, skip rendering
        if (wareHouseModel && item.id === 10) return null;
        if (!wareHouseModel && item.id === 18) return null;
      const showLock = !wareHouseModel && (item.id === 3 || item.id === 4);

      const enabledAutoWhatsappNotification = brandProfileData.enabledAutoWhatsappNotification;
      const enabledB2BModelBrand = brandProfileData.enabledB2BModel;
      const enabledB2BModelStore = storeData.enabledB2BModel;

      const enabledRackModelBrand = brandProfileData.enabledRackModel;
      const rackModelType = storeData.rackModelType;

      if (!enabledAutoWhatsappNotification && item.id === 12) return null;
      if ((!enabledB2BModelBrand || !enabledB2BModelStore) && item.id === 14) return null;
      if ((!enabledRackModelBrand || rackModelType !== "auto") && item.id === 15) return null;
      if ((!enabledRackModelBrand || rackModelType !== "manual") && item.id === 16) return null;
      if ((!enabledRackModelBrand || rackModelType !== "manual") && item.id === 17) return null;
      //  if (!packageCarryForwardStore && item.id === 13) return null;

      return (
        <div className="flex-1">
          <div className="flex-1  surface-0" style={{ "--surface-0": "#ccc" }}>
            <div style={{ height: 1 }}></div>
          </div>
          <div
            className="flex flex-row my-2 h-3rem cursor-pointer"
            onClick={() => {
              if (!showLock) {
                navigate(item.url);
                setVisible(!visible);
              }
            }}
          >
            <div
              className="flex justify-content-center"
              style={{ alignSelf: "center" ,width: 70}}
            >
              <img
                src={item.backgroundImage}
                style={{ width: item.width, height: item.height }}
              />
            </div>
            <div style={{ alignSelf: "center", flex:1 }}>
              <p className="text-xl font-medium">{item.name}</p>
            </div>
            <div style={{alignSelf: "center" ,width: 40}}>
              {showLock && (
                <img
                  src={"Icons/lock.png"}
                  style={{ width: item.width, height: item.height }}
                />
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  const renderCardRiderItem = () => {
    return CardDataRider?.map((item, index) => (
      <div className="flex-1">
        <div className="flex-1  surface-0" style={{ "--surface-0": "#ccc" }}>
          <div style={{ height: 1 }}></div>
        </div>
        <div
          className="flex flex-row my-3 h-3rem cursor-pointer"
          onClick={() => {
            navigate(item.url);
            setVisible(!visible);
          }}
        >
          <div
            className="flex justify-content-center"
            style={{ flex: 0.7, alignSelf: "center" }}
          >
            <img
              src={item.backgroundImage}
              style={{ width: item.width, height: item.height }}
            />
          </div>
          <div style={{ flex: 2, alignSelf: "center" }}>
            <p className="text-xl font-medium">{item.name}</p>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div>
      <Sidebar
        visible={visible}
        onHide={() => setVisible(false)}
        position="right"
        content={({ closeIconRef, hide }) => (
          <div className="min-h-screen flex relative lg:static surface-ground">
            <div
              id="app-sidebar-2"
              className="surface-section h-screen block flex-shrink-0 absolute lg:static left-0 top-0 z-1 border-right-1 surface-border select-none"
              style={{ width: "280px" }}
            >
              <div className="flex flex-column h-full">
                <div
                  className="flex align-items-center justify-content-between px-2 pt-2 flex-shrink-0 surface-0"
                  style={{
                    "--surface-0": "#1752AA",
                  }}
                >
                  <div className="flex flex-1">
                    <div
                      className="flex align-items-center justify-content-center w-3 cursor-pointer"
                      onClick={() => navigate("/UserProfile")}
                      style={{
                        height: 65,
                        width: 65,

                        borderRadius: 50,
                        backgroundColor: "#fff",
                      }}
                    >
                      {storeData.logo ? (
                        <img
                          src={`data:image/png;base64,${storeData.logo}`}
                          style={{ width: 50, height: 50 }}
                        />
                      ) : (
                        <img
                          src={
                            userRole === "BY_RIDER"
                              ? "warehouse/delivery-boy.png"
                              : "warehouse/warehouse_2.png"
                          }
                          style={{ width: 50, height: 50 }}
                        />
                      )}
                    </div>
                    <div className="ml-2 w-9">
                      <p className="text-2xl font-medium text-white">
                        {userProfileData.firstName?.replace(/_/g, " ")}{" "}
                        {userProfileData.lastName?.substring(0, 6)}
                        {userProfileData.lastName?.length > 6 ? "..." : ""}
                      </p>
                      <p className="text-xl font-medium text-white">
                        {userRole === "BY_RIDER" ? "Rider" : "Manager"} -{" "}
                        {storeData.storeName
                          .replace(/_/g, " ")
                          .substring(0, 12)}
                        {storeData.storeName.length > 12 ? "..." : ""}
                      </p>
                      <p
                        className="text-md font-normal text-white"
                        style={{
                          wordWrap: "break-word",
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {userProfileData.email}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="overflow-y-auto">
                  {userRole === "BY_RIDER"
                    ? renderCardRiderItem()
                    : renderCardItem()}
                </div>
              </div>
            </div>
          </div>
        )}
      ></Sidebar>
    </div>
  );
}
